import { render, staticRenderFns } from "./informerCard.vue?vue&type=template&id=d3781726&"
import script from "./informerCard.vue?vue&type=script&lang=js&"
export * from "./informerCard.vue?vue&type=script&lang=js&"
import style0 from "../style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports